import { Spinner } from "reactstrap";
import React from 'react';

interface ICenterSpinnerProps {
  showLoader: boolean;
  className?: string;
}

const CenterSpinner: React.FunctionComponent<ICenterSpinnerProps> = ({
  className,
  showLoader,
}) => {
  return (
    <>
      {showLoader && (
        <div
          className={`spinner-element ${className ? className : "spinner-center"
            }`}
        >
          <img
            src={require('../../assets/images/loading.gif')}
            className="spinner-img"
          />
        </div>
      )}
    </>
  );
};

export default CenterSpinner;
